import { useEffect } from 'react';

const BASE_URL = 'https://skyboard.es';
const OG_IMAGE = 'https://customer-assets.emergentagent.com/job_6c9f827d-2b98-4123-8d21-968baa0ee9cb/artifacts/o9dp6cfp_hero-avion-skyboard.png';

function setMeta(name, content, attr = 'name') {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href, attrs = {}) {
  const selector = Object.entries(attrs).map(([k, v]) => `[${k}="${v}"]`).join('');
  let el = document.querySelector(`link[rel="${rel}"]${selector}`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function getLangCode(lang) {
  if (lang === 'es') return 'es';
  if (lang === 'de') return 'de';
  return 'en';
}

export function usePageMeta({ title, description, path = '', lang = 'es' }) {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = getLangCode(lang);

    setMeta('description', description);
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:url', `${BASE_URL}${path}`, 'property');
    setMeta('og:image', OG_IMAGE, 'property');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('twitter:image', OG_IMAGE);

    setLink('canonical', `${BASE_URL}${path}`);

    const langMap = { es: 'es_ES', en: 'en_GB', de: 'de_DE' };
    setMeta('og:locale', langMap[lang] || 'es_ES', 'property');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, lang]); // BASE_URL, OG_IMAGE, getLangCode, setMeta, setLink are stable module-level constants/functions
}

export const seoData = {
  es: {
    home: {
      title: 'Skyboard | Simulador de negocios de aerolíneas para MBAs y programas ejecutivos',
      description: 'Skyboard es la plataforma de simulación de negocios de aerolíneas más inmersiva para desarrollar habilidades estratégicas. Diseñada para MBAs, escuelas de negocios y formación ejecutiva.',
    },
    contact: {
      title: 'Contacto | Skyboard - Simulador de aerolíneas',
      description: 'Contacta con Skyboard para solicitar una demostración personalizada del simulador de negocios de aerolíneas para MBAs y programas ejecutivos.',
    },
    privacy: {
      title: 'Política de Privacidad | Skyboard',
      description: 'Política de Privacidad de Skyboard. Información sobre el tratamiento de datos personales conforme al RGPD, LOPD-GDD y LSSI-CE.',
    },
    terms: {
      title: 'Términos de Servicio | Skyboard',
      description: 'Términos y condiciones de uso del sitio web de Skyboard, simulador de negocios de aerolíneas.',
    },
  },
  en: {
    home: {
      title: 'Skyboard | Airline Business Simulator for MBAs and Executive Programs',
      description: 'Skyboard is the most immersive airline business simulation platform for developing strategic skills. Designed for MBAs, business schools, and executive education.',
    },
    contact: {
      title: 'Contact | Skyboard - Airline Simulator',
      description: 'Contact Skyboard to request a personalized demonstration of the airline business simulator for MBAs and executive programs.',
    },
    privacy: {
      title: 'Privacy Policy | Skyboard',
      description: 'Skyboard Privacy Policy. Information on personal data processing in compliance with GDPR, LOPD-GDD and LSSI-CE.',
    },
    terms: {
      title: 'Terms of Service | Skyboard',
      description: 'Terms and conditions of use for the Skyboard website, airline business simulator.',
    },
  },
  de: {
    home: {
      title: 'Skyboard | Airline-Business-Simulator fur MBAs und Executive-Programme',
      description: 'Skyboard ist die immersivste Airline-Business-Simulationsplattform zur Entwicklung strategischer Kompetenzen. Entwickelt fur MBAs, Business Schools und Executive Education.',
    },
    contact: {
      title: 'Kontakt | Skyboard - Airline-Simulator',
      description: 'Kontaktieren Sie Skyboard fur eine personalisierte Demonstration des Airline-Business-Simulators fur MBAs und Executive-Programme.',
    },
    privacy: {
      title: 'Datenschutzerklarung | Skyboard',
      description: 'Datenschutzerklarung von Skyboard. Informationen zur Verarbeitung personenbezogener Daten gemass DSGVO.',
    },
    terms: {
      title: 'Nutzungsbedingungen | Skyboard',
      description: 'Nutzungsbedingungen der Skyboard-Website, Airline-Business-Simulator.',
    },
  },
};
